export default {
    encode(str){
        return window.btoa(unescape(encodeURIComponent( str )));
    },
    decode(b64){
        return decodeURIComponent(escape(window.atob( b64 )));
    }
}